import { VectorProps } from './types';

const ArrowDown = ({ className, size = 1, color = 'currentColor' }: VectorProps) => {
  return (
    <svg className={className} width={`${size}em`} viewBox="0 0 32 32">
      <path
        fill={color}
        d="m29.7 14.2h-3.17c-0.18 0-0.352 0.0777-0.473 0.214l-8.56 9.81v-21.9c0-0.171-0.141-0.311-0.313-0.311h-2.35c-0.172 0-0.313 0.14-0.313 0.311v21.9l-8.56-9.81c-0.117-0.136-0.289-0.214-0.473-0.214h-3.17c-0.266 0-0.411 0.315-0.235 0.513l13 14.9a1.25 1.24 0 0 0 1.89 0l13-14.9c0.176-0.202 0.0314-0.513-0.235-0.513z"
      />
    </svg>
  );
};

export default ArrowDown;
